import { jsxs as i, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as e } from "./index.es2447.js";
function t({ size: l = e }) {
  return /* @__PURE__ */ i(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M36 31.5C37.933 31.5 39.5 29.933 39.5 28C39.5 26.067 37.933 24.5 36 24.5C34.067 24.5 32.5 26.067 32.5 28C32.5 29.933 34.067 31.5 36 31.5Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.0342 16.5C30.9502 16.5 33.6134 17.579 35.6442 19.358L27.382 27.5964L35.6272 36.6568C33.5985 38.427 30.9421 39.5 28.0342 39.5C24.8493 39.5 21.966 38.2129 19.8788 36.1323C17.7911 34.051 16.5 31.1758 16.5 28C16.5 24.8242 17.7911 21.949 19.8788 19.8677C21.966 17.7871 24.8493 16.5 28.0342 16.5Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.2318 20.2218C22.2289 18.2309 24.9867 17 28.0342 17C30.6316 17 33.0183 17.8942 34.9032 19.3908L27.0289 27.2423C26.8397 27.431 26.8323 27.7352 27.0122 27.9329L34.9059 36.6071C33.0206 38.1049 30.6329 39 28.0342 39C24.9867 39 22.2289 37.7691 20.2318 35.7782C18.2342 33.7868 17 31.0374 17 28C17 24.9626 18.2342 22.2132 20.2318 20.2218ZM28.0342 16C24.7119 16 21.703 17.3432 19.5258 19.5136C17.348 21.6847 16 24.6858 16 28C16 31.3142 17.348 34.3153 19.5258 36.4864C21.703 38.6568 24.7119 40 28.0342 40C31.0674 40 33.8396 38.8803 35.9559 37.0336C36.0572 36.9452 36.1187 36.8198 36.1264 36.6856C36.1341 36.5514 36.0875 36.4197 35.997 36.3203L28.0733 27.6132L35.9972 19.7121C36.0953 19.6143 36.1484 19.4802 36.1439 19.3419C36.1395 19.2035 36.0778 19.0731 35.9736 18.9819C33.855 17.126 31.0758 16 28.0342 16ZM33 28C33 26.3431 34.3431 25 36 25C37.6569 25 39 26.3431 39 28C39 29.6569 37.6569 31 36 31C34.3431 31 33 29.6569 33 28ZM36 24C33.7909 24 32 25.7909 32 28C32 30.2091 33.7909 32 36 32C38.2091 32 40 30.2091 40 28C40 25.7909 38.2091 24 36 24Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
t.__tags = [];
export {
  t as MetricCannibalizationIcon
};
//# sourceMappingURL=index.es401.js.map
